import { colors } from './theme';

export const ui = {
  title: { fontSize: 24, fontWeight: 700, margin: '0 0 20px', color: colors.text },
  card: { background: colors.surface, border: `1px solid ${colors.border}`, borderRadius: 12, padding: 20, marginBottom: 16 },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 14 },
  th: { textAlign: 'left', padding: '10px 12px', color: colors.textMuted, fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.5, borderBottom: `1px solid ${colors.border}` },
  td: { padding: '10px 12px', borderBottom: `1px solid ${colors.border}`, color: colors.text },
  input: { padding: '10px 12px', background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: 8, fontSize: 14, color: colors.text, outline: 'none' },
  textarea: { padding: '10px 12px', background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: 8, fontSize: 14, color: colors.text, outline: 'none', fontFamily: 'inherit', resize: 'vertical' },
  btn: { background: colors.accent, color: colors.bg, border: 'none', padding: '10px 16px', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: 'pointer' },
  btnSecondary: { background: 'transparent', color: colors.text, border: `1px solid ${colors.border}`, padding: '10px 16px', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  btnDanger: { background: 'transparent', color: colors.danger, border: `1px solid ${colors.danger}`, padding: '8px 12px', borderRadius: 8, fontSize: 13, cursor: 'pointer' },
  badge: (bg, fg) => ({ display: 'inline-block', padding: '3px 10px', borderRadius: 999, fontSize: 12, fontWeight: 600, background: bg, color: fg }),
  empty: { color: colors.textMuted, fontSize: 14, padding: 20, textAlign: 'center' },
  error: { background: '#3a1c1c', border: '1px solid #7a3030', color: colors.danger, padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 12 },
  row: { display: 'flex', gap: 10, alignItems: 'center', marginBottom: 16, flexWrap: 'wrap' },
};

export const statusBadge = {
  active: ['#1c3a2a', colors.good],
  incomplete: ['#2a2a3a', colors.textMuted],
  awaiting_interview: ['#3a3320', colors.warn],
  no_show: ['#3a2a20', colors.warn],
  hidden_auto: ['#2a2a3a', colors.textMuted],
  hidden_manual: ['#2a2a3a', colors.textMuted],
  blocked: ['#3a1c1c', colors.danger],
  deleted: ['#242430', colors.textMuted],
  open: ['#3a3320', colors.warn],
  answered: ['#1c3a2a', colors.good],
  closed: ['#2a2a3a', colors.textMuted],
  booked: ['#3a3320', colors.warn],
  completed: ['#1c3a2a', colors.good],
  cancelled: ['#2a2a3a', colors.textMuted],
};
